import {
  Box, Container, Wrap,
  Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';
import {
  useRef,
} from 'react';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import TerritorialActivityPopulation from './components/report-sections/TerritorialActivityPopulation';
import TerritorialActivityEconomic from './components/report-sections/TerritorialActivityEconomic';
import TerritorialActivityReportHeader from './components/report-headers/TerritorialActivityReportHeader';
import DataDisclaimer from '../../components/DataDisclaimer';

function TerritorialActivity() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Territorial Activity"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>This page provides information on population and Gross Domestic Product (GDP) for the network.</Text>
              <Text mb={4}>The population size and growth that the road network supports is a key determinator for the volume of traffic on the roads.</Text>
              <Text>The GDP in a network is also an indicator of the volume of traffic on the roads, especially heavy traffic for industries that use heavy vehicle haulage.</Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <TerritorialActivityReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <TerritorialActivityPopulation />
            <TerritorialActivityEconomic />
          </Wrap>
          <DataDisclaimer />
        </Box>
      </Container>
    </MainLayout>
  );
}

export default TerritorialActivity;
